/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Next_Step_UnconfiguredInputs */

const cs_sms_next_step_unconfigured = /** @type {(inputs: Sms_Next_Step_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další krok: nastavte SMS_PROVIDER=twilio a Twilio údaje na serveru, nebo nechte stub pro vývoj.`)
};

const en_sms_next_step_unconfigured = /** @type {(inputs: Sms_Next_Step_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step: set SMS_PROVIDER=twilio and Twilio credentials on the server, or keep stub for development.`)
};

/**
* | output |
* | --- |
* | "Next step: set SMS_PROVIDER=twilio and Twilio credentials on the server, or keep stub for development." |
*
* @param {Sms_Next_Step_UnconfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_next_step_unconfigured = /** @type {((inputs?: Sms_Next_Step_UnconfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Next_Step_UnconfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_next_step_unconfigured(inputs)
	return cs_sms_next_step_unconfigured(inputs)
});